import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { BottomSheet, Divider, RadioListItem, ScrollView, Stack, } from '@adc/parallax-component-library';
import i18n from 'Utilities/i18n';
const CountryBottomSheetModal = ({ isOpen, onCancel, onDone, countries, selectedCountry, title, }) => {
    const [selectedItem, setSelectedItem] = useState('');
    const ref = useRef(null);
    useEffect(() => {
        if (isOpen) {
            ref.current?.present();
        }
        else {
            ref.current?.dismiss();
        }
    }, [isOpen]);
    useEffect(() => {
        if (selectedCountry && isOpen) {
            setSelectedItem(selectedCountry);
        }
    }, [selectedCountry, isOpen]);
    const orderedCountryList = useMemo(() => {
        const allCountries = countries || [];
        return allCountries
            .filter((country) => i18n.exists(`Global.microcopy.countries.${country.toUpperCase()}`))
            .map((country) => ({
            code: country.toUpperCase(),
            name: i18n.t(`Global.microcopy.countries.${country.toUpperCase()}`),
        }))
            .sort((a, b) => a.name.localeCompare(b.name));
    }, [countries]);
    const handleCancelAction = useCallback(() => {
        setSelectedItem('');
        onCancel();
    }, [onCancel]);
    const handleDone = useCallback(() => {
        if (selectedItem) {
            onDone(selectedItem);
            if (ref && 'current' in ref && ref.current) {
                ref.current.close();
            }
        }
        else {
            onCancel();
        }
    }, [selectedItem, onDone, onCancel]);
    return (React.createElement("div", null,
        React.createElement(BottomSheet, { topNavigationProps: {
                title,
                buttonStart: {
                    element: i18n.t('Global.microcopy.common.cancel').toString(),
                    onPress: handleCancelAction,
                    label: i18n.t('Global.microcopy.common.cancel'),
                },
                buttonEnd: {
                    element: i18n.t('Global.microcopy.common.done').toString(),
                    onPress: handleDone,
                    label: i18n.t('Global.microcopy.common.done'),
                },
            }, snapPoints: ['99%'], ref: ref, onBackdropClick: handleCancelAction, onDismiss: handleCancelAction, scrollable: false, testID: "CountryBottomSheetModal" },
            React.createElement(ScrollView, { nestedScrollEnabled: true }, orderedCountryList.map(({ code, name }) => {
                return (React.createElement(Stack, { key: code },
                    React.createElement(RadioListItem, { key: code, title: name, "aria-label": name, disabled: false, selected: selectedItem === code, onPress: () => setSelectedItem(code), testID: `Country.${code}` }),
                    React.createElement(Divider, { borderColor: "$neutral.20" })));
            })))));
};
export { CountryBottomSheetModal };
